import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'

// 全局样式
import './assets/css/global.scss'

Vue.use(ElementUI, { size: 'medium' })

Vue.config.productionTip = false

// 全局兜底：接口异常（拦截器已统一 toast 提示）未被页面 catch 时，
// 阻止其冒泡成 Uncaught (in promise)，避免开发环境全屏红色错误遮罩
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason
  if (reason && (reason.__handled || reason.isAxiosError)) {
    event.preventDefault()
  }
})

// 全局过滤器：去除HTML标签
Vue.filter('stripHTMLTags', function (value) {
  if (!value) return ''
  return value.replace(/(<([^>]+)>)/gi, '').replaceAll('&nbsp;', '')
})

// 全局过滤器：日期格式化
Vue.filter('formatDate', function (value) {
  if (!value) return ''
  const date = new Date(value)
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
